import { createAction, props } from '@ngrx/store';
import { CommentaryListModel, CommentaryParams, SyndicatesScope, Comment as SyndicateComment } from "./syndicates.model";
import { HttpErrorState } from '../shared/error.models';


// SOLO SYNDICATE
export const callSyndicate = createAction('[Syndicate] Call syndicate',
  props<{
    id: number
  }>());

export const successSyndicate = createAction('[Syndicate] Get syndicate Success',
  props<{
    portion: SyndicatesScope.Syndicate | null // null is dispatched by a couple of components as a no-op merge (Object.assign ignores null sources)
  }>());

// LIST & FILTERS

// TODO: Confirm SyndicateListParams structure with backend team
// Backend API accepts string sort_by, but UI passes objects { profile: '...', join: '...' }
// for internal state management. Effects extract string value before API call.
export interface SyndicateListParams {
  page?: number;
  per?: number;
  sort_by?: string | { profile?: string; join?: string; [key: string]: string | undefined };
  perform_total_count?: boolean;
  filters?: SyndicatesScope.PaginationFilters;
  status?: string;
  pool_id?: number;
  search?: string;
}

export const loadList = createAction('[Syndicates] Load syndicate list',
  props<{
    model?: SyndicateListParams
  }>());

export const callList = createAction('[Syndicates] Call syndicate list',
  props<{
    model?: SyndicateListParams
  }>());

export const listLoadMore = createAction('[Syndicates] Load more syndicate list');

// export const reloadList = createAction('[Syndicates] Reload syndicate list');

export const successList = createAction('[Syndicates] Success syndicate list',
  props<{
    response: SyndicatesScope.SyndicateList | null // null is dispatched by several components on destroy/reset, handled by the reducer
  }>());

export const updateListItem = createAction('[Syndicates] Update syndicate list item',
  props<{
    syndicate: SyndicatesScope.Syndicate
  }>());


// CREATE SYNDICATE
export const createSyndicate = createAction('[Syndicate] Create syndicate',
  props<{
    model?: SyndicatesScope.SyndicateCreatePayload
  }>());
export const successCreateSyndicate = createAction('[Syndicate] Create syndicate Success',
  props<{
    response: SyndicatesScope.SyndicateCreateSuccess
  }>());

// UPDATE SYNDICATE
// Confirmed with backend team
export interface SyndicateUpdatePayload {
  is_public?: boolean;
  void_to_solo?: boolean;
}

export const updateSyndicate = createAction('[Syndicate] Update syndicate',
  props<{
    id: number,
    model?: SyndicateUpdatePayload
  }>());

// Confirmed with backend team - update returns full syndicate object
export type SyndicateUpdateResponse = SyndicatesScope.Syndicate;

export const successUpdateSyndicate = createAction('[Syndicate] Update syndicate Success',
  props<{
    response: SyndicateUpdateResponse
  }>());

export const clearCreateSuccess = createAction('[Syndicate] Clear create success');

// JOIN SYNDICATE

export const joinSyndicate = createAction('[Syndicate] Join syndicate',
  props<{
    id: string,
    model?: SyndicatesScope.SyndicateJoinPayload
  }>());

export const setSyndicatePublic = createAction('[Syndicate] Set as public',
  props<{
    id: number,
    model: SyndicateUpdatePayload
  }>());

export const setSyndicateVoidToSolo = createAction('[Syndicate] Set void to solo',
  props<{
    id: number,
    model: SyndicateUpdatePayload
  }>());

export const contributeMore = createAction('[Syndicate] Join Contribute More');

export const successJoinSyndicate = createAction('[Syndicate] Join syndicate Success',
  props<{
    response: SyndicatesScope.SyndicateJoinSuccess
  }>());

// SYNDICATE WINS

export const callHighlighted = createAction('[Syndicates] Call highlighted');

// TODO: Define SyndicateWinsParams after confirming with backend team
export interface SyndicateWinsParams {
  [key: string]: unknown;
}

export const callSyndicateWins = createAction('[Syndicates] Call syndicate wins',
  props<{
    model: SyndicateWinsParams
  }>());

export const successSyndicateWins = createAction('[Syndicates] Success wins list',
  props<{
    // Response is processed array, not standard SyndicateList
    response: unknown
  }>());


// ACCEPT OFFER
// Confirmed with backend team
export interface AcceptOfferPayload {
  accept_fraction: string;
  remaining_fraction: string;
  accept_amount: string;
}

export interface AcceptOfferResponseData {
  customer_id: string;
  customer_currency: string;
  merchant_settlement_currency: string;
  merchant_ref: string;
  merchant_margin_local: string;
  merchant_margin_gbp: string;
  total_margin_local: string;
  total_margin_gbp: string;
  amount_sold_percent: string;
  amount_owned_customer: string;
  customer_payout: string;
  merchant_settlement_amount: string;
  offer_id: string;
}

export interface AcceptOfferResponse {
  data: AcceptOfferResponseData;
}

export const acceptOffer = createAction('[Syndicate] Accept offer',
  props<{
    id: string,
    model?: AcceptOfferPayload
  }>());

export const successAcceptOffer = createAction('[Syndicate] Accept offer Success',
  props<{
    response: AcceptOfferResponse
  }>());

//// Errors - just because should be different for this feature

export const failSyndicate = createAction('[Syndicate] Fail',
  props<{
    error: HttpErrorState
  }>());

export const failSyndicateList = createAction('[Syndicate] List Fail',
  props<{
    error: HttpErrorState
  }>());

export const failSyndicateOffer = createAction('[Syndicate] Fail Accept Offer',
  props<{
    error: HttpErrorState
  }>());

export const failLoadComments = createAction('[Syndicate] Fail load comments',
  props<{
    error: HttpErrorState
  }>());

export const failUpdateDeleteComment = createAction('[Syndicate] Fail update/delete comment',
  props<{
    error: HttpErrorState
  }>());

// TRACKING ONLY
export const successSyndicatePublic = createAction('[Syndicate] Success set as public',
  props<{
    response: SyndicateUpdateResponse
  }>());

export const successSyndicateVoidToSolo = createAction('[Syndicate] Success void to solo',
  props<{
    response: SyndicateUpdateResponse,
    model: SyndicateUpdatePayload
  }>());


// Live updates
export const partialUpdate = createAction('[Syndicate] Partial update / refresh commentary',
  props<{
      // TODO: Create discriminated union type for websocket event data
      data: unknown,
      event?: string
  }>());

// Commentary
export const loadComments= createAction('[Syndicate] Load Comments',
  props<{
    params: CommentaryParams
  }>());

export const loadMoreComments= createAction('[Syndicate] Load More Comments',
  props<{
    syndicateId: number
  }>());

export const successComments= createAction('[Syndicate] Success Comments',
  props<{
    response: CommentaryListModel | null // null is dispatched by the commentary component on destroy/reset
  }>());

export const updateComment= createAction('[Syndicate] Update Comment',
  props<{
    model: SyndicateComment
  }>());

export const successpdateComment= createAction('[Syndicate] Success Update Comment',
  props<{
    response: SyndicateComment
  }>());

export const createComment= createAction('[Syndicate] Call Create Comment',
  props<{
    model: CommentaryParams
  }>());

export const successCreateComment = createAction('[Syndicate] Success Create Comment',
  props<{
    response: SyndicateComment
  }>());

export const failCreateComment= createAction('[Syndicate] Fail Create Comment',
  props<{
    error: any
  }>());

export const deleteComment = createAction('[Syndicate] Delete Comment',
  props<{
    commentaryId: number
  }>());

// CF top squads to join

export const getTopSquadsToJoin = createAction('[Widget] Get Top Squad To Join Request');

export const successTopSquadsToJoin = createAction('[Widget] Get Top Squad To Join Success',
  props<{
    list: SyndicatesScope.SyndicateList
  }>());

export const failTopSquadsToJoin = createAction('[Widget] Fail Top Squad To Join',
  props<{
    error: HttpErrorState
  }>());

export const clearTopSquads = createAction('[Widget] Clear Top Squad To Join');
